import { __ } from '@wordpress/i18n'
import { 
	Fragment,
	useEffect, 
	useRef
} from '@wordpress/element'

import { 
	ServerSideRender, PanelBody, ToggleControl, SelectControl, TextControl, TextareaControl, BaseControl 
} from '@wordpress/components'
import { 
	DesignPanelBody, ButtonControlsHelper, ImageControl, URLInputControl
} from '~cartzillagb/components'
import { 
	 isYithWcWlActive, isWoocommerceActive, themeAssetsURL, i18n, isYithCompareActive 
} from 'cartzillagb'
import ImageDesignBasic from './images/basic.png'
import ImageDesignPlain from './images/plain.png'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import {
	withTabbedInspector, withClickOpenInspector
} from '~cartzillagb/higher-order'
import $ from 'jquery'
import classnames from 'classnames'

import { 
	withSelect 
} from '@wordpress/data'


addFilter( 'cartzillagb.header.edit.inspector.style.before', 'cartzillagb/header', ( output, props ) => {
	const { attributes, setAttributes, isSelected, menuOptions, classnames } = props
	const {
		enableFullwidth,
		enableHeaderSticky,
		enableAccount,
		enableCart,
		design,
		enableSearch,
		departmentTitle,
		enableDepartmentMenu,
		departmentIcon,
		enableButton,
		skin,
		contactInfo,
		promo,
		logoImageID = 0,
        logoImageUrl = '',
        enableSupportInfo,
        supportInfoTitle,
        supportInfoIcon,
        supportText,
        supportLink,
        enableWishlist,
        enableSiteContactInfo,
        contactInfoIcon,
        contactText,
        contactLink,
        contactInfoTitle,
        enableheaderSocialMenu,
        socialMenuTitle,
        buttonText,
        buttonUrl,
        enableTopbar,
        mobileLogoImageID,
        mobileLogoImageUrl,
        enableGroceryDepartmentMenu,
        headerPrimaryMenuId,
        headerDepartmentMenuID,
        headerOffcanvasMenuID,
        headerHandheldDepartmentMenuID,
        enableOrderTracking,
        enableCompare,
        enableLanguageCurrency,

        headerPrimaryMenuSlug,
        headerDepartmentMenuSlug,
        headerHandheldDepartmentMenuSlug,
        headerOffcanvasMenuSlug

	} = attributes

	const openUrlPopover = ( isSelected !== null ? isSelected : true ) 


	return (
		<Fragment>
			<DesignPanelBody
				initialOpen={ true }
				selected={ design }
				options={ applyFilters( 'cartzillagb.header.edit.layouts', [
					{
						 label: __( '1 Level Light', i18n ), value: '1-level-light', image: ImageDesignBasic,
					},
					{
						label: __( '1 Level Dark', i18n ), value: '1-level-dark', image: ImageDesignPlain,
					},
					{
						label: __( '2 Level Light', i18n ), value: '2-level-light', image: ImageDesignBasic,
					},
					{
						label: __( '2 Level Dark', i18n ), value: '2-level-dark', image: ImageDesignPlain,
					},
					{
						label: __( '3 Level Light', i18n ), value: '3-level-light', image: ImageDesignBasic,
					},
					{
						label: __( '3 Level Dark', i18n ), value: '3-level-dark', image: ImageDesignPlain,
					},

					{
						label: __( 'Electronics Store', i18n ), value: 'electronics-store', image: ImageDesignBasic,
					},
					{
						label: __( 'Marketplace', i18n ), value: 'marketplace', image: ImageDesignPlain,
					},

					{
						label: __( 'Grocery', i18n ), value: 'grocery', image: ImageDesignBasic,
					},
				  ] ) }
				 onChange={ design => setAttributes( { design } ) }
			  >
			 </DesignPanelBody>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				{ design !== 'grocery' && 
					<ToggleControl
						label={ __( 'Make header full-width?', i18n ) }
						checked={ enableFullwidth }
						onChange={ enableFullwidth => setAttributes( { enableFullwidth } ) }
					/>
				}

                { ( design !== '1-level-light' && design !== '1-level-dark' && design !== 'grocery' ) && 
	                <ToggleControl
						label={ __( 'Enable Topbar', i18n ) }
						checked={ enableTopbar }
						onChange={ enableTopbar => setAttributes( { enableTopbar } ) }
					/>
				}
                { design !== 'grocery' && 
					<ToggleControl
						label={ __( 'Make header sticky?', i18n ) }
						checked={ enableHeaderSticky }
						onChange={ enableHeaderSticky => setAttributes( { enableHeaderSticky } ) }
					/>
				}
				{ isWoocommerceActive  &&
					<Fragment>
						<ToggleControl
							label={ __( 'Show account?', i18n ) }
							checked={ enableAccount }
							onChange={ enableAccount => setAttributes( { enableAccount } ) }
						/>
						<ToggleControl
							label={ __( 'Show cart?', i18n ) }
							checked={ enableCart }
							onChange={ enableCart => setAttributes( { enableCart } ) }
						/>
					</Fragment>
				}

				{ isYithWcWlActive && 
					<ToggleControl
						label={ __( 'Enable Wishlist', i18n ) }
						checked={ enableWishlist }
						onChange={ enableWishlist => setAttributes( { enableWishlist } ) }
					/>
				}

				<ToggleControl
					label={ __( 'Show search?', i18n ) }
					checked={ enableSearch }
					onChange={ enableSearch => setAttributes( { enableSearch } ) }
				/>
				<ToggleControl
					label={ __( 'Enable Button', i18n ) }
					checked={ enableButton }
					onChange={ enableButton => setAttributes( { enableButton } ) }
				/>
				{ design === 'grocery' && 
					<Fragment>
						<ToggleControl
							label={ __( 'Enable Support Info', i18n ) }
							checked={ enableSupportInfo }
							onChange={ enableSupportInfo => setAttributes( { enableSupportInfo } ) }
						/>

						<ToggleControl
							label={ __( 'Enable Contact Info', i18n ) }
							checked={ enableSiteContactInfo }
							onChange={ enableSiteContactInfo => setAttributes( { enableSiteContactInfo } ) }
						/>

						<ToggleControl
							label={ __( 'Header Social Menu', i18n ) }
							checked={ enableheaderSocialMenu }
							onChange={ enableheaderSocialMenu => setAttributes( { enableheaderSocialMenu } ) }
						/>
					</Fragment>
				}
				
			</PanelBody>   
			<PanelBody title={ __( "Logo Settings", i18n ) } initialOpen={ true }>
				<Fragment>
					<ImageControl
	                    label={ __( 'Upload logo', i18n ) }
	                    onRemove={ media => {
	                        setAttributes( { logoImageID: 0 } )
	                        setAttributes( { logoImageUrl: '' } )
	                    } }
	                    onChange={ media => {
	                        setAttributes( { logoImageID: media.id } )
	                        setAttributes( { logoImageUrl: media.url } )
	                    } }
	                    render={ <img src={ `${ themeAssetsURL }img/logo-dark.png` } alt={ __( 'logo' ) }/> }
	                    imageID={ logoImageID }
	                    imageURL={ logoImageUrl }
	                    allowedTypes={ [ 'image' ] }

	                />

	                <ImageControl
	                    label={ __( 'Upload mobile logo', i18n ) }
	                    onRemove={ media1 => {
	                        setAttributes( { mobileLogoImageID: 0 } )
	                        setAttributes( { mobileLogoImageUrl: '' } )
	                    } }
	                    onChange={ media1 => {
	                        setAttributes( { mobileLogoImageID: media1.id } )
	                        setAttributes( { mobileLogoImageUrl: media1.url } )
	                    } }
	                    render={ <img src={ `${ themeAssetsURL }img/logo-icon-dark.png` } alt={ __( 'logo' ) }/> }
	                    imageID={ mobileLogoImageID }
	                    imageURL={ mobileLogoImageUrl }
	                    allowedTypes={ [ 'image' ] }

		            />
		          
	           	</Fragment>
            </PanelBody>

            <PanelBody title={ __( "Menu Settings", i18n ) } initialOpen={ false }>
            	<Fragment>
	            	{ design !== 'grocery' &&
	            		<SelectControl
		                    label={ __( 'Select a primary menu', i18n ) }
		                    options={ menuOptions }
		                    value={ headerPrimaryMenuSlug }
		                    onChange={ headerPrimaryMenuSlug => setAttributes( { headerPrimaryMenuSlug } ) }
		                />
		            }
				
		            { ( design === '3-level-light' ||  design === '3-level-dark' || design === 'marketplace' || design === 'electronics-store' ) && 
		            	<Fragment>
				          
			            	<SelectControl
			                    label={ __( 'Select a department menu', i18n ) }
			                    options={ menuOptions }
			                    value={ headerDepartmentMenuSlug }
			                    onChange={ headerDepartmentMenuSlug => setAttributes( { headerDepartmentMenuSlug } ) }
			                />
		                </Fragment>
		            }

		            { design === 'grocery' &&
		            	<SelectControl
		                    label={ __( 'Select a primary menu', i18n ) }
		                    options={ menuOptions }
		                    value={ headerOffcanvasMenuSlug }
		                    onChange={ headerOffcanvasMenuSlug => setAttributes( { headerOffcanvasMenuSlug } ) }
		                />
		            }

	            
                </Fragment>
             </PanelBody>

			{ ( design !== '1-level-light' &&  design !== '1-level-dark' &&  design !== 'grocery' && enableTopbar ) && 
				<PanelBody title={ __( "Topbar Settings", i18n ) } initialOpen={ false }>
					<SelectControl
						label={ __( 'Skin', i18n ) }
						values={ skin }
						options={ [
							{ label: __('Light', 'cartzilla', i18n ), value: 'light' },
							{ label: __('Dark', 'cartzilla', i18n ), value: 'dark' },
						] }
						onChange={ skin => setAttributes( { skin } ) }
					/>
					<ToggleControl
						label={ __( 'Enable Language Currency', i18n ) }
						checked={ enableLanguageCurrency }
						onChange={ enableLanguageCurrency => setAttributes( { enableLanguageCurrency } ) }
					/>
					<TextareaControl
						label={ __( 'Contact Information', i18n ) }
						value={ contactInfo }
						placeholder={ __( 'Support', i18n ) }
						onChange={ contactInfo => setAttributes( { contactInfo } ) }
					/>
					<TextareaControl
						label={ __( 'Promo', i18n ) }
						value={ promo }
						placeholder={ __( 'Free shipping for order over $200', i18n ) }
						onChange={ promo  => setAttributes( { promo } ) }
					/>

					{ ( isWoocommerceActive  && ( design === 'electronics-store' || design === '2-level-light' || design === '2-level-dark' || design === '3-level-light' || design === '3-level-dark' ) ) && 
						<ToggleControl
							label={ __( 'Show Order Tracking', i18n ) }
							checked={ enableOrderTracking }
							onChange={ enableOrderTracking => setAttributes( { enableOrderTracking } ) }
						/>
					}

					{ isYithCompareActive && 
						<ToggleControl
							label={ __( 'Enable Compare', i18n ) }
							checked={ enableCompare }
							onChange={ enableCompare => setAttributes( { enableCompare } ) }
						/>
					}
					
				</PanelBody> 
			} 

			{ ( design === '3-level-light' ||  design === '3-level-dark' || design === 'marketplace' || design === 'electronics-store' ) &&  
				<PanelBody title={ __( "Navigation Settings", i18n ) } initialOpen={ false }>
						
					<Fragment>  
						<ToggleControl
							label={ __( 'Show "Departments" (categories) menu?', i18n ) }
							checked={ enableDepartmentMenu }
							onChange={ enableDepartmentMenu => setAttributes( { enableDepartmentMenu } ) }
						/>
						<TextControl
							label={  __( '"Departments" title', i18n ) }
							value={ departmentTitle }
							placeholder={ __( 'Departments', i18n ) }
							onChange={ departmentTitle => setAttributes( { departmentTitle } ) }
						/>
						<TextControl
							label={  __( '"Departments" Icon Class', i18n ) }
							value={ departmentIcon }
							onChange={ departmentIcon => setAttributes( { departmentIcon } ) }
						/>
					</Fragment>
						
				</PanelBody> 
			}

			{ design === 'grocery' && 
				<PanelBody title={ __( "Navigation Settings", i18n ) } initialOpen={ false }>
					<Fragment>
						<TextControl
							label={  __( '"Departments" title', i18n ) }
							value={ departmentTitle }
							placeholder={ __( 'Departments', i18n ) }
							onChange={ departmentTitle => setAttributes( { departmentTitle } ) }
						/>

						<ToggleControl
							label={ __( 'Show "Departments" (categories) menu?', i18n ) }
							checked={ enableGroceryDepartmentMenu }
							onChange={ enableGroceryDepartmentMenu => setAttributes( { enableGroceryDepartmentMenu } ) }
						/>

						{ enableGroceryDepartmentMenu && 
							<SelectControl
			                    label={ __( 'Select a department menu', i18n ) }
			                    options={ menuOptions }
			                    value={ headerHandheldDepartmentMenuSlug }
			                    onChange={ headerHandheldDepartmentMenuSlug => setAttributes( { headerHandheldDepartmentMenuSlug } ) }
			                />
						}

					</Fragment>
				</PanelBody>
			}

			{ ( design === 'grocery' && enableSupportInfo ) &&
				<PanelBody title={ __( "Support Info Settings", i18n ) } initialOpen={ false }>
					<Fragment>
							<TextControl
								label={  __( 'Support Info Title', i18n ) }
								value={ supportInfoTitle }
								placeholder={ __( 'Support', i18n ) }
								onChange={ supportInfoTitle => setAttributes( { supportInfoTitle } ) }
							/>

							<TextControl
								label={  __( 'Support Info Icon', i18n ) }
								value={ supportInfoIcon }
								placeholder={ __( 'czi-support', i18n ) }
								onChange={ supportInfoIcon => setAttributes( { supportInfoIcon } ) }
							/>

							<TextareaControl
								label={ __( 'Support Text', i18n ) }
								value={ supportText }
								placeholder={ __( '+1 (00) 33 169 7720', i18n ) }
								onChange={ supportText  => setAttributes( { supportText } ) }
							/>

							<TextControl
								label={  __( 'Support Link', i18n ) }
								value={ supportLink }
								placeholder={ __( 'tel:+100331697720', i18n ) }
								onChange={ supportLink => setAttributes( { supportLink } ) }
							/>
							
						</Fragment>
					</PanelBody>
					
				}

				{ ( design === 'grocery' && enableSiteContactInfo ) &&
					<PanelBody title={ __( "Contact Info Settings", i18n ) } initialOpen={ false }>
						<Fragment>
							<TextControl
								label={  __( 'Contact Info Title', i18n ) }
								value={ contactInfoTitle }
								placeholder={ __( 'Email', i18n ) }
								onChange={ contactInfoTitle => setAttributes( { contactInfoTitle } ) }
							/>

							<TextControl
								label={  __( 'Contact Info Icon', i18n ) }
								value={ contactInfoIcon }
								placeholder={ __( 'czi-mail', i18n ) }
								onChange={ contactInfoIcon => setAttributes( { contactInfoIcon } ) }
							/>

							<TextareaControl
								label={ __( 'Contact Text', i18n ) }
								value={ contactText }
								placeholder={ __( 'customer@example.com', i18n ) }
								onChange={ contactText  => setAttributes( { contactText } ) }
							/>

							<TextControl
								label={  __( 'Contact Text Link', i18n ) }
								value={ contactLink }
								placeholder={ __( 'tel:+100331697720', i18n ) }
								onChange={ contactLink => setAttributes( { contactLink } ) }
							/>
								
						</Fragment>
					</PanelBody>
				
				}
				{ ( design === 'grocery' && enableheaderSocialMenu ) &&
					<PanelBody title={ __( "Social Info Settings", i18n ) } initialOpen={ false }>
						<TextControl
							label={  __( 'Social Menu Title', i18n ) }
							value={ socialMenuTitle }
							placeholder={ __( 'Follow us', i18n ) }
							onChange={ socialMenuTitle => setAttributes( { socialMenuTitle } ) }
						/>
					</PanelBody>

				}
			

			{ enableButton && 
				<Fragment>
					<PanelBody title={ __( 'Button Settings', i18n ) }initialOpen={ false } >
						<ButtonControlsHelper
							attrNameTemplate="button%s"
							setAttributes={ setAttributes }
							blockAttributes={ props.attributes }
						/>

						<TextControl
	                        label={ __('Text' ) }
	                        value={ buttonText }
	                        onChange={ buttonText => setAttributes( { buttonText } ) }
	                    />


	                    { openUrlPopover &&
		                    <URLInputControl
		                        value={ buttonUrl }
		                        onChange={ buttonUrl => setAttributes( { buttonUrl } ) }
		                    />
		                }

					</PanelBody>
				 </Fragment>
			}

		</Fragment>

		
	)
} )

const edit = props => {
	useEffect( () => {
		if ( $( '.cz-carousel' ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( '.js-slick-carousel.slick-initialized' ).slick( 'unslick' )
		} 
	})
	return (
		<ServerSideRender
			block="czgb/header"
			attributes={ props.attributes }
		/>
	)
}

export default compose(
	withSelect( select => {
		const { getEntityRecords } = select( 'core' )
	    const menusList = getEntityRecords( 'taxonomy', 'nav_menu', { 'hide_empty': false, 'orderby': 'name', 'per_page': -1 } )

	    let menuOptions = [];

	    if( menusList && menusList.length > 0 ) {
	        menuOptions = menusList.map( ( menu ) => ( {
	            label: menu.name,
	            value: menu.slug
	        } ) )
	    }

	    menuOptions.unshift({
	        label: __( 'Default' ),
	        value: 0
	    })

	    return {
	        menuOptions: menuOptions,
	    }
	}),

	withTabbedInspector( [ 'style', 'advanced' ] ),
	withClickOpenInspector( [
		[ '.czgb-button', 'button' ],
	] )
)( edit )